module.exports = {"timestamp":"10:47 14/02/19"}


//////////////////
// WEBPACK FOOTER
// ./src/utils/timestamp.json
// module id = 246
// module chunks = 0